import React from 'react';

/**
 * A corner badge naming the environment, shown on everything except production.
 *
 * Three environments now sit behind near-identical URLs with near-identical
 * data (dev and uat run on an anonymised copy of production). The badge is the
 * cheap insurance against acting on — or demoing — the wrong one. It renders
 * nothing when REACT_APP_ENV is 'prod' or unset, so production is untouched.
 *
 * Inline styles on purpose: this must render independently of MUI's theme and
 * before Emotion has injected anything.
 */
const COLORS: Record<string, string> = {
  dev: '#0e7490',
  uat: '#b45309',
};

export default function EnvBadge() {
  const env = process.env.REACT_APP_ENV;
  if (!env || env === 'prod') return null;

  return (
    <div
      aria-label={`${env} environment`}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        zIndex: 2147483647,
        padding: '3px 10px',
        borderTopRightRadius: 6,
        background: COLORS[env] || '#4b5563',
        color: '#fff',
        font: '600 11px/1.4 system-ui, sans-serif',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      {env}
    </div>
  );
}
